module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDE2IDEyIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjE1IiBoZWlnaHQ9IjExIiB4PSIuNSIgeT0iLjUiIHN0cm9rZT0iIzAwMCIgcng9IjIiLz4KICAgIDxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik0xIDNoMTR2MkgxeiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/components/icons/credit-card.svg
// module id = 1676
// module chunks = 2